
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import {
  deltConfig,
  editCheckoutConfig,
  getCheckoutList,
  setCheckoutConfig,
} from '@/api/merchant/product'
import { AppModule } from '@/store/modules/app'
import { checkoutCounter } from '@/utils/rules'

@Component({
  name: 'config',
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) merchant_no!: string
  @Prop({ required: true }) info!: any

  get language() {
    return AppModule.language
  }
  private listLoading: boolean = false
  private loading: boolean = false
  private list: any[] = []
  private rules = checkoutCounter
  private accountType: any[] = []

  private queryFrom: any = {
    merchant_no: this.merchant_no,
    product: this.info.product,
  }

  private from: any = {
    product: this.info.product,
    account_type: '',
    path: null,
    name: '',
  }
  private edirFrom: any = {}

  private back() {
    this.$emit('close')
  }

  private arrFunction() {
    this.list.forEach((v: any) => {
      v.account_type
      if (v.account_type) {
        this.accountType.splice(v.account_type, 1)
      }
      // if (v.path) {
      //   this.info.checkout_counter_path.splice(v.path, 1)
      // }
    })
  }

  // 创建收银台配置
  private openAddVisible: boolean = false
  private openAdd() {
    this.openAddVisible = true
    // this.arrFunction()
  }
  private closeAdd() {
    this.openAddVisible = false
    this.from = {
      product: this.info.product,
      account_type: '',
      path: null,
    }
    // this.arrFunction()
    this.getList()
  }
  private addConfig() {
    ;(this.$refs.from as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          const data: any = {
            merchant_no: this.merchant_no,
            ...this.from,
          }
          await setCheckoutConfig(data).then(() => {
            if (this.language === 'en') {
              this.$message({
                message: 'Create successful!',
                type: 'success',
              })
            } else if (this.language === 'zh_cn') {
              this.$message({
                message: '创建成功！',
                type: 'success',
              })
            } else if (this.language === 'zh_tw') {
              this.$message({
                message: '創建成功！',
                type: 'success',
              })
            }
            this.loading = false
            this.closeAdd()
          })
        } catch (e) {
          this.loading = false
        }
      } else {
        return false
      }
    })
  }

  // 编辑收银台设置
  private openEditVisible: boolean = false
  private openEdit(row: any) {
    this.openEditVisible = true
    this.edirFrom = row
  }
  private closeEdit() {
    this.openEditVisible = false
    this.getList()
  }
  private editConfig() {
    ;(this.$refs.edirFrom as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          const data: any = {
            merchant_no: this.merchant_no,
            id: this.edirFrom.id,
            ...this.edirFrom,
          }
          await editCheckoutConfig(data).then(() => {
            if (this.language === 'en') {
              this.$message({
                message: 'Edit successful!',
                type: 'success',
              })
            } else if (this.language === 'zh_cn') {
              this.$message({
                message: '编辑成功！',
                type: 'success',
              })
            } else if (this.language === 'zh_tw') {
              this.$message({
                message: '編輯成功！',
                type: 'success',
              })
            }
            this.loading = false
            this.closeEdit()
          })
          this.loading = false
        } catch (e) {
          this.loading = false
        }
      } else {
        return false
      }
    })
  }

  // 删除收银台配置
  private del(id: any) {
    this.$confirm('Are you sure to delete it?', {
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      type: 'warning',
      callback: (action) => {
        if (action === 'confirm') {
          this.delConfig(id)
        }
      },
    })
  }
  private async delConfig(id: any) {
    const data: any = {
      id: id,
      merchant_no: this.merchant_no,
    }
    await deltConfig(data).then(() => {
      if (this.language === 'en') {
        this.$message({
          message: 'Delete successful!',
          type: 'success',
        })
      } else if (this.language === 'zh_cn') {
        this.$message({
          message: '删除成功！',
          type: 'success',
        })
      } else if (this.language === 'zh_tw') {
        this.$message({
          message: '刪除成功！',
          type: 'success',
        })
      }
      this.getList()
    })
  }

  // 获取收银台配置列表
  private async getList() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryFrom,
      }
      await getCheckoutList(data).then((res: any) => {
        this.list = res
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  mounted() {
    this.getList()
    console.log(this.info)

    for (const key in this.$store.state.app.constant[
      'PRODUCT_ACCOUNT_PARAM_TEMPLATE'
    ][this.info.product_name]) {
      this.accountType.push(key)
    }
  }
}
